import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { SENDOTP, VERIFYOTP } from '../../data/url';
import Alert from '../../utils/Alert';
import httpClient from '../../http/HttpRequest';

export default function LoginModal(props) {

    const { show, handleClose, mobile } = props;

    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [otpRef, setOtpRef] = useState('');
    const [otpSent, setOtpSent] = useState(false);

    useEffect(() => {
        if (mobile) {
            setMobileNumber(mobile);
        }
    }, [mobile]);

    const closeModal = () => {
        handleClose(false);
    }

    const handelSubmit = async (e) => {
        e.preventDefault();
        if(otp.trim() !== ''){
            let payload = {ref_no:otpRef,otp:otp};           
            const res = await httpClient.plainRequest(VERIFYOTP, payload);
            if (res.requestStatus === "OK") {
                const result = res.result;
                if (result.status === 1) {                    
                    Alert.success(result.message);
                    if (result.token === undefined) {
                        handleClose(false,{otpVerify:1})
                    } else {
                        handleClose(false,{token:result.token})
                    }                    
                } else {
                    Alert.error(result.message);
                }
            }      
        }else{
            Alert.error('OTP is required!');
        }
    }

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    }

    const onMobileChange = (e) => {
        if (!mobile) {
            setMobileNumber(e.target.value);
        }
     }

    const sentOtp = async (e) => {
        if (mobileNumber.trim() !== '') {
            let payload = { mobile: mobileNumber };
            const res = await httpClient.plainRequest(SENDOTP, payload);
            if (res.requestStatus === "OK") {
                const result = res.result;
                if (result.status === 1) {
                    setOtpRef(result.ref_no);
                    setOtpSent(true);
                    Alert.success(result.message);
                } else {
                    Alert.error(result.message);
                }
            }
        }
    }

    return (
        <Modal show={show} onHide={closeModal} keyboard={false} backdrop="static">
            <form className="pt-3" onSubmit={(e) => handelSubmit(e)}>
                <Modal.Header>
                    <Modal.Title>Login</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12 mb-2">
                        <label className='form-label'>Mobile Number</label>
                        <input
                            type="text"
                            name="mobile"
                            value={mobileNumber}
                            onChange={onMobileChange}
                            className="form-control"
                            placeholder="Your Mobile"
                        />
                    </div>
                    {!otpSent &&
                        <div className="col-12 mb-2 float-right">
                            <button type='button' className='btn btn-primary btn-sm' onClick={sentOtp}>SEND OTP</button>
                        </div>
                    }
                    {otpSent &&
                        <div className="col-12 mb-2">
                            <label className='form-label'>OTP</label>
                            <input
                                type="text"
                                name="otp"
                                value={otp}
                                onChange={handleOtpChange}
                                className="form-control"
                                placeholder="Enter OTP"
                            />
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal} className='btn-sm'>
                        Close
                    </Button>
                    {otpSent &&
                        <Button variant="primary" type='submit' className='btn-sm'>
                            VERIFY
                        </Button>
                    }
                </Modal.Footer>
            </form>
        </Modal>
    )
}
